import { TRuleWithTheme } from 'styles/theme';

export const button: TRuleWithTheme = ({ theme }) => ({
    width: '100%',
    marginTop: '1rem',
    color: theme.colors.white,
});
